import { CommonModule } from '@angular/common';
import { AfterViewInit,ChangeDetectionStrategy,Component,EventEmitter,Input,OnDestroy,Output,ViewChild } from '@angular/core';
import { MatLegacyListModule as MatListModule,MatLegacySelectionList as MatSelectionList } from '@angular/material/legacy-list';
import { compareArrays,TableColumnConfig } from '../helper/helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-table-config-form[columns]',
    standalone: true,
    imports: [CommonModule, MatListModule],
    templateUrl: './table-config-form.component.html',
    styleUrls: ['./table-config-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableConfigFormComponent<T extends {}, K extends PropertyKey = keyof T> implements AfterViewInit, OnDestroy {
    @Input() columns: TableColumnConfig<T, K>[];
    protected _selectedColumns: K[] = [];
    @Input() set selectedColumns(string: K[]) {
        if (!compareArrays(this._selectedColumns, string)) {
            this._selectedColumns = string;
        }
    }
    get selectedColumns() {
        return this._selectedColumns;
    }
    @Output() selectedColumnsChange = new EventEmitter<Array<K>>();
    @ViewChild(MatSelectionList) columnSelectionList: MatSelectionList;

    private destroy$ = new Subject<void>();

    ngAfterViewInit(): void {
        this.columnSelectionList.selectionChange.pipe(takeUntil(this.destroy$)).subscribe((selection) => {
            let curr = this._selectedColumns.slice();
            selection.options.forEach((o) => {
                if (o.selected) {
                    curr.push(o.value);
                } else {
                    curr = curr.filter((co) => co !== o.value);
                }
            });
            this._selectedColumns = curr.sort((a, b) => this.columns.findIndex((v) => v.name === a) - this.columns.findIndex((v) => v.name === b));
            this.selectedColumnsChange.emit(this._selectedColumns);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete()
    }

    identify(index: number, item: TableColumnConfig<T>) {
        return item.name;
    }
}
